import React, {useEffect, useState} from "react";
import './index.scss';
import TwisterTile from "./twister-tile";

const initSelected = (widgetAttributes: any) => {
    //Today we only support 2 twister tile for Kyanite, we can expand here more if ever we have >2 twisters.
    return widgetAttributes[0]?.isSelected ? 0 : widgetAttributes[1]?.isSelected ? 1 : -1;
}

const TwisterTileWidget = (widgetAttributes: any) => {
    const firstElements = document.querySelectorAll<HTMLElement>("#" + widgetAttributes[0]?.idSelector);
    const secondElements = document.querySelectorAll<HTMLElement>("#" + widgetAttributes[1]?.idSelector);
    const [selectedTwister, setSelectedTwister] = useState(() => initSelected(widgetAttributes));

    useEffect(() => {
        switch (selectedTwister) {
            case 0:
                if (firstElements.length !== 0) {
                    firstElements.forEach(el => el.style.display = "block");
                }
                if (secondElements.length !== 0) {
                    secondElements.forEach(el => el.style.display = "none");
                }
                break;
            case 1:
                if (firstElements.length !== 0) {
                    firstElements.forEach(el => el.style.display = "none");
                }
                if (secondElements.length !== 0) {
                    secondElements.forEach(el => el.style.display = "block");
                }
                break;
            default:
                if (firstElements.length !== 0) {
                    firstElements.forEach(el => el.style.display = "none");
                }
                if (secondElements.length !== 0) {
                    secondElements.forEach(el => el.style.display = "none");
                }
        }
    }, [selectedTwister]);


    return (
        <pui-section class="twister-tile-widget" flowdirection="horizontal" fullwidth>
            {!!widgetAttributes[0] && <TwisterTile {...widgetAttributes[0]} position="left" isSelected={selectedTwister === 0}
                                                   onClick={() => setSelectedTwister(0)}/>}
            {!!widgetAttributes[1] && <pui-text class="twister-tile-seperator" fontWeight="bold" input="or"/>}
            {!!widgetAttributes[1] && <TwisterTile {...widgetAttributes[1]} position="right" isSelected={selectedTwister === 1}
                                                   onClick={() => setSelectedTwister(1)}/>}
        </pui-section>
    )
}

export default TwisterTileWidget;